export const EVENTS_SCHEMA_VERSION = "0.56.0";
export const PAGE_VIEWS_SCHEMA_VERSION = "0.28.0";
